import { Models } from '@rematch/core';
import { account } from './accountModel';
import { alert } from './alertModel';
import { app } from './appModel';
import { cart } from './cartModel';
import { companyGallery } from './companyGalleryModel';
import { eqpt } from './eqptModel';
import { excelDefinition } from './excelDefinitionModal';
import { galleryLabel } from './galleryLabelModel';
import { gallery } from './galleryModel';
import { industryAvg } from './industryAvgModel';
import { jobConfig } from './jobConfigModel';
import { jobEstimator } from './jobEstimatorModel';
import { markup } from './markupModel';
import { mat } from './matModel';
import { network } from './networkModel';
import { order } from './orderModel';
import { org } from './orgModel';
import { parcel } from './parcelModel';
import { project } from './projectModel';
import { resellerCertificate } from './resellerCertificateModel';
import { shipping } from './shippingModel';
import { sku } from './skuModel';
import { svc } from './svcModel';
import { tf } from './tfModel';
import { uploadFile } from './uploadModel';
import { workspaceDetail } from './workspaceDetailModel';
import { workspace } from './workspaceModel';
import { rfm } from './workspaceRfmModel';
import { sla } from './slaModel';

export interface RootModel extends Models<RootModel> {
  app: typeof app;
  eqpt: typeof eqpt;
  mat: typeof mat;
  org: typeof org;
  markup: typeof markup;
  companyGallery: typeof companyGallery;
  network: typeof network;
  parcel: typeof parcel;
  account: typeof account;
  shipping: typeof shipping;
  svc: typeof svc;
  industryAvg: typeof industryAvg;
  tf: typeof tf;
  uploadFile: typeof uploadFile;
  workspace: typeof workspace;
  cart: typeof cart;
  workspaceDetail: typeof workspaceDetail;
  order: typeof order;
  sku: typeof sku;
  rfm: typeof rfm;
  jobConfig: typeof jobConfig;
  gallery: typeof gallery;
  alert: typeof alert;
  galleryLabel: typeof galleryLabel;
  jobEstimator: typeof jobEstimator;
  excelDefinition: typeof excelDefinition;
  resellerCertificate: typeof resellerCertificate;
  project: typeof project;
  sla: typeof sla;
}

export const models: RootModel = {
  app,
  eqpt,
  mat,
  org,
  markup,
  companyGallery,
  network,
  parcel,
  account,
  shipping,
  svc,
  industryAvg,
  tf,
  uploadFile,
  workspace,
  cart,
  workspaceDetail,
  order,
  sku,
  rfm,
  jobConfig,
  gallery,
  alert,
  galleryLabel,
  jobEstimator,
  excelDefinition,
  resellerCertificate,
  project,
  sla,
};
